import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  IconButton,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { APIUrlToken, APIUrlTwo, GetUserId, logEvent } from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, Chip } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LinkedINImage from "../../Assets/linkedin.svg";
import massageicon from "../../Assets/FrameDiff.svg";
import company from "../../Assets/people-logo.png";
import education from "../../Assets/cap-logo.png";
import experience from "../../Assets/jobcompany.png";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import partnerimg from "../../Assets/partnerimg.svg";
import Siderbardeleteicon from "../../Assets/Delete.svg";
import Loader from "../Loader/Loader";

const RightSidebarMobile = ({ openSidebar, setOpenSidebar }) => {
  // const peopleDetailsFav = openSidebar?.people_details
  const loggedInUserId = GetUserId();
  const [dataShortestPath, setDataShortestPath] = useState([]);
  const [alternativePath, setAlternativePath] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [buttonVisible, setButtonVisible] = React.useState(false);

  const toggleButtonVisibility = () => {
    setButtonVisible(!buttonVisible);
  };
  const initialNodes = dataShortestPath;
  const handleRightsidebar = (event) => {
    logEvent("shortest-path", "JOI");
    const data = {};
    data.source_uid = Number(loggedInUserId);
    data.target_uid = Number(
      event?.person_id ?? event?.people_details?.person_id,
    );
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlTwo()}/v1/shortest-path`,
    };
    axios(option)
      .then((response) => {
        if (response?.status === 200) {
          const data = Object.values(response.data);
          setDataShortestPath(data);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (openSidebar) {
      handleRightsidebar(openSidebar);
    }
  }, [openSidebar]);

  function combineNodesAndEdges(nodes, edges) {
    const combinedArray = [];
    edges?.forEach((edge) => {
      const sourceNode = nodes?.find((node) => node.uid === edge.source);
      const targetNode = nodes?.find((node) => node.uid === edge.destination);
      if (sourceNode && targetNode) {
        combinedArray?.push({
          ...sourceNode,
          ...edge,
          target: targetNode.uid,
        });
      }
    });
    const lastNode = nodes?.find(
      (node) => !edges.some((edge) => edge.source === node.uid),
    );
    if (lastNode) {
      combinedArray.push(lastNode);
    }
    return combinedArray;
  }

  // AlternativePath
  let addingAlternate = [];
  let addingAlternateData = [];
  alternativePath?.forEach((item) => {
    const upcomingAlternate = combineNodesAndEdges(
      item?.bestPathInfor?.nodes,
      item?.bestPathInfor?.edges,
    );
    addingAlternateData.push(upcomingAlternate);
  });
  addingAlternate = addingAlternateData || [];

  // Best path
  const BestPathNodes = combineNodesAndEdges(
    initialNodes?.[0]?.bestPathInfor?.nodes,
    initialNodes?.[0]?.bestPathInfor?.edges,
  );
  const bestPathinnodes = BestPathNodes;

  //Shortesr path
  const ShortPathNodes = combineNodesAndEdges(
    initialNodes?.[0]?.shortestPath?.nodes,
    initialNodes?.[0]?.shortestPath?.edges,
  );
  const shortPathinnodes = ShortPathNodes || [];

  function compareNodes(node1, node2) {
    return node1.uid === node2.uid;
  }

  const filterUniqueArrays = (data) => {
    const uniqueArrays = new Set();
    return data.filter((subArray) => {
      const jsonString = JSON.stringify(subArray);
      if (uniqueArrays.has(jsonString)) {
        return false;
      }
      uniqueArrays.add(jsonString);
      return true;
    });
  };

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };
  const handleDeleteNode = (item) => {
    setLoading(true);
    const data = {};
    data.source_uid = Number(loggedInUserId);
    data.target_uid = dataShortestPath[0]?.target;
    const arr = [item?.uid];
    data.nodes_uid = arr;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlTwo()}/v1/remove_node`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        setButtonVisible(!buttonVisible);
        if (response?.data[0]?.bestPathInfor?.message !== "Have Path") {
          toast.error("No further paths available");
        }
        if (alternativePath?.length > 0) {
          const data = [...alternativePath, response.data?.[0]];
          const filtered = filterUniqueArrays(data);
          const filterWeighted = filtered.filter((item) => {
            const bestPathNodes = initialNodes?.[0]?.bestPathInfor?.nodes || [];
            const itemNodes = item?.bestPathInfor?.nodes || [];

            if (bestPathNodes?.length !== itemNodes?.length) return true;

            return !bestPathNodes.every((node, index) =>
              compareNodes(node, itemNodes[index]),
            );
          });

          if (alternativePath?.length == filterWeighted?.length) {
            toast.error("No further paths available");
          }
          setAlternativePath(filterWeighted);
        } else {
          alternativePath.push(response.data?.[0]);
        }
        if (response?.status === 200) {
          toast.success(response?.data?.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(
          error?.response?.data?.message || "No further paths available",
        );
      });
  };

  const [isTabPortrait, setIsTabPortrait] = React.useState(false);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)",
    );

    const handler = (e) => {
      setIsTabPortrait(e.matches); // true if media query matches
    };

    // Initial check
    handler(mediaQuery);

    mediaQuery.addEventListener("change", handler);

    return () => {
      mediaQuery.removeEventListener("change", handler);
    };
  }, []);
  const [clicked, setClicked] = React.useState(false);

  const handleCopy = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy);
    setClicked(true);
  };
  return (
    <>
      {loading ? <Loader /> : null}

      <Slide
        direction="left"
        in={openSidebar}
        mountOnEnter
        unmountOnExit
        className={
          window?.location.pathname.includes("aileads") ||
          window?.location.pathname.includes("aidecisionmakers")
            ? "aip-filter-mb-slide-leads-mob"
            : window?.location.pathname.includes("companyprofilescreen")
              ? "aip-filter-mb-slide-fav-mob-company"
              : "aip-filter-mb-slide-fav-mob"
        }
        style={{ paddingBottom: "70px", backgroundColor: "#f3f4f9 " }}
      >
        <Box
          sx={{
            position: "fixed",
            top: isTabPortrait ? "33px" : "0",
            left: isTabPortrait ? "" : "0",
            width: isTabPortrait ? "calc(100vw - 240px)" : "100%",
            right: isTabPortrait ? "0px" : "",
            height: "100vh",
            bgcolor: "white",
            zIndex: 10,
            boxShadow: 2,
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          <div
            className={
              window?.location.pathname.includes("companyprofilescreen")
                ? "aip-path-slide-box-sidebar-company"
                : window?.location.pathname.includes("favoritesList")
                  ? "aip-path-slide-box-sidebar-fav-tab"
                  : window?.location.pathname.includes("aileads")
                    ? "aip-path-slide-box-sidebar-leads-mob"
                    : window?.location.pathname.includes("aidecisionmakers")
                      ? "aip-path-slide-box-sidebar-leads-mob"
                      : "aip-path-slide-box-sidebar-fav"
            }
          >
            {/* Panel Header */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              // px={2}
              py={1.5}
            >
              <>
                <IconButton onClick={() => setOpenSidebar("")}>
                  {/* <ArrowBackIosNewIcon fontSize="small" /> */}
                </IconButton>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  style={{ textTransform: "capitalize" }}
                >
                  {openSidebar?.first_name} {openSidebar?.last_name}
                </Typography>
                <IconButton
                  onClick={() => {
                    setOpenSidebar("");
                    setAlternativePath([]);
                    setButtonVisible(false);
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </>
            </Box>
            <div className="aip-path-btn">
              <button
                onClick={() => toggleButtonVisibility()}
                style={{ fontSize: "14px" }}
              >
                {buttonVisible
                  ? "Disable Alternate Paths"
                  : "Enable Alternate Paths"}
              </button>
            </div>
            {addingAlternate
              .slice()
              .reverse()
              .map((myItem, index) => {
                return myItem?.length ? (
                  <>
                    <Box>
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        gutterBottom
                        style={{ color: "#7C7C7C", marginTop: "20px" }}
                      >
                        Alternate Path {addingAlternate?.length - index}
                      </Typography>

                      <Stack>
                        {myItem.map((user, index) => (
                          <>
                            <Card
                              key={index}
                              variant="outlined"
                              sx={{ borderRadius: 3, boxShadow: 1, my: 0 }}
                            >
                              <CardContent
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  p: 1,
                                }}
                              >
                                <div className="rightsidebar-box-mainouter">
                                  <div className="rightsidebar-box-mainouter-first">
                                    <div className="rightsidebar-box-mainouter-one">
                                      {" "}
                                      <Avatar
                                        sx={{ bgcolor: "primary.main", mr: 2 }}
                                      >
                                        {getInitials(user.name)}
                                      </Avatar>
                                    </div>

                                    {/* User Info */}
                                    <div className="rightsidebar-box-mainouter-two">
                                      <Box sx={{ flexGrow: 1 }}>
                                        <Typography
                                          variant="subtitle1"
                                          fontWeight="600"
                                        >
                                          {user.name}
                                        </Typography>
                                        <Typography
                                          variant="body2"
                                          color="text.secondary"
                                          sx={{
                                            fontSize: 13,
                                            wordBreak: "break-word", // breaks long strings
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {user.company}
                                        </Typography>
                                        <Typography
                                          variant="body2"
                                          color="text.secondary"
                                          sx={{ fontSize: 12 }}
                                          style={{
                                            wordWrap: "break-word",
                                          }}
                                        >
                                          <Typography sx={{ fontSize: 12 }}>
                                            {user?.email?.length > 18
                                              ? user?.email?.slice(0, 18) +
                                                "..."
                                              : user?.email}
                                          </Typography>
                                        </Typography>
                                        <Link
                                          href={user?.linkedin}
                                          target="_blank"
                                          // underline="hover"
                                          sx={{
                                            fontSize: 12,
                                            display: "block",
                                            color: "#0004FF",
                                          }}
                                        >
                                          {user?.linkedin?.split("/").pop()}
                                        </Link>
                                      </Box>
                                    </div>
                                  </div>
                                  {/* Email Button */}
                                  {/* <div className="rightsidebar-box-mainouter-three">
                                    <IconButton
                                      color="error"
                                      className="aip-email"
                                    >
                                      <EmailOutlinedIcon />
                                    </IconButton>
                                  </div> */}
                                  <div className="rightsidebar-box-mainouter-three">
                                    {buttonVisible &&
                                      !(index === 0) &&
                                      !(
                                        index ===
                                        bestPathinnodes?.length - 1
                                      ) && (
                                        <div className="">
                                          <button
                                            style={{ fontSize: "14px" }}
                                            className="DeleteButtonVisible-mobile"
                                            onClick={() =>
                                              handleDeleteNode(user)
                                            }
                                          >
                                            <img
                                              src={Siderbardeleteicon}
                                              alt=""
                                            />
                                          </button>
                                        </div>
                                      )}

                                    <IconButton
                                      component="a"
                                      href={`mailto:${user?.email}`}
                                      color="error"
                                      className="aip-email"
                                    >
                                      <EmailOutlinedIcon />
                                    </IconButton>
                                  </div>{" "}
                                </div>
                              </CardContent>
                            </Card>
                            {user.weight && (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  my: 0,
                                }}
                              >
                                <Chip
                                  label={user.weight}
                                  variant="outlined"
                                  sx={{
                                    borderRadius: 2,
                                    fontWeight: "bold",
                                    margin: "10px",
                                  }}
                                />
                                <span className="aip-mb-path"></span>
                                <div className="aip-mb-relation">
                                  {user?.relation && (
                                    <div className="siderbar-image-container-right-sidebar">
                                      <div className="Siderbar-lits-images">
                                        {user?.relation?.includes("Email") && (
                                          <img
                                            src={massageicon}
                                            alt=""
                                            className="siderbar-modal-img"
                                          />
                                        )}
                                        {user?.relation?.includes(
                                          "LinkedIn",
                                        ) && (
                                          <img
                                            src={LinkedINImage}
                                            alt=""
                                            className="siderbar-modal-img"
                                          />
                                        )}
                                        {user?.relation?.includes(
                                          "Organization",
                                        ) && (
                                          <img
                                            src={company}
                                            alt=""
                                            className="siderbar-modal-img"
                                          />
                                        )}
                                        {user?.relation?.includes(
                                          "Education",
                                        ) && (
                                          <img
                                            src={education}
                                            alt=""
                                            className="siderbar-modal-img"
                                          />
                                        )}
                                        {user?.relation?.includes(
                                          "Experience",
                                        ) && (
                                          <img
                                            src={experience}
                                            alt=""
                                            className="siderbar-modal-img"
                                          />
                                        )}
                                        {user?.relation?.includes(
                                          "Meeting",
                                        ) && (
                                          <CalendarMonthIcon className="siderbar-modal-img" />
                                        )}
                                        {user?.relation?.includes(
                                          "Partner",
                                        ) && (
                                          <img
                                            src={partnerimg}
                                            alt=""
                                            className="siderbar-modal-img"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {/* {buttonVisible &&
                                    !(index === 0) &&
                                    !(index === myItem?.length - 1) && (
                                      <div className="">
                                        <button
                                          style={{ fontSize: "14px" }}
                                          className="DeleteButtonVisible"
                                          onClick={() => handleDeleteNode(user)}
                                        >
                                          <img
                                            src={Siderbardeleteicon}
                                            alt=""
                                          />
                                          Remove
                                        </button>
                                      </div>
                                    )} */}
                                </div>
                              </Box>
                            )}
                          </>
                        ))}
                      </Stack>
                    </Box>
                  </>
                ) : null;
              })}
            <Box>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                gutterBottom
                style={{ color: "#7C7C7C", marginTop: "20px" }}
              >
                Weighted Path
              </Typography>

              <Stack>
                {bestPathinnodes.map((user, index) => (
                  <>
                    <Card
                      key={index}
                      variant="outlined"
                      sx={{ borderRadius: 3, boxShadow: 1, my: 0 }}
                    >
                      <CardContent
                        sx={{ display: "flex", alignItems: "center", p: 1 }}
                      >
                        <div className="rightsidebar-box-mainouter">
                          <div className="rightsidebar-box-mainouter-first">
                            <div className="rightsidebar-box-mainouter-one">
                              <Avatar sx={{ bgcolor: "primary.main", mr: 2 }}>
                                {getInitials(user.name)}
                              </Avatar>
                            </div>
                            <div className="rightsidebar-box-mainouter-two">
                              <Box sx={{ flexGrow: 1 }}>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="600"
                                >
                                  {user.name}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    fontSize: 13,
                                    wordBreak: "break-word", // breaks long strings
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {user.company}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{ fontSize: 12 }}
                                  style={{
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {user?.email?.length > 18
                                    ? user?.email?.slice(0, 18) + "..."
                                    : user?.email}{" "}
                                </Typography>
                                <Link
                                  href={user?.linkedin}
                                  target="_blank"
                                  // underline="hover"
                                  sx={{
                                    fontSize: 12,
                                    display: "block",
                                    color: "#0004FF",
                                  }}
                                >
                                  {user.linkedin?.split("/").pop()}
                                </Link>
                              </Box>
                            </div>
                          </div>
                          <div className="rightsidebar-box-mainouter-three">
                            {buttonVisible &&
                              !(index === 0) &&
                              !(index === bestPathinnodes?.length - 1) && (
                                <div className="">
                                  <button
                                    style={{ fontSize: "14px" }}
                                    className="DeleteButtonVisible-mobile"
                                    onClick={() => handleDeleteNode(user)}
                                  >
                                    <img src={Siderbardeleteicon} alt="" />
                                  </button>
                                </div>
                              )}

                            <IconButton
                              component="a"
                              href={`mailto:${user?.email}`}
                              color="error"
                              className="aip-email"
                            >
                              <EmailOutlinedIcon />
                            </IconButton>
                          </div>{" "}
                        </div>
                      </CardContent>

                      {/* Bottom Score Badge */}
                    </Card>
                    {user.weight && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          my: 0,
                        }}
                      >
                        <Chip
                          label={user.weight}
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            fontWeight: "bold",
                            margin: "10px",
                          }}
                        />
                        <span className="aip-mb-path"></span>
                        <div className="aip-mb-relation">
                          {user?.relation && (
                            <div className="siderbar-image-container-right-sidebar">
                              <div className="Siderbar-lits-images">
                                {user?.relation?.includes("Email") && (
                                  <img
                                    src={massageicon}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                                {user?.relation?.includes("LinkedIn") && (
                                  <img
                                    src={LinkedINImage}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                                {user?.relation?.includes("Organization") && (
                                  <img
                                    src={company}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                                {user?.relation?.includes("Education") && (
                                  <img
                                    src={education}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                                {user?.relation?.includes("Experience") && (
                                  <img
                                    src={experience}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                                {user?.relation?.includes("Meeting") && (
                                  <CalendarMonthIcon className="siderbar-modal-img" />
                                )}
                                {user?.relation?.includes("Partner") && (
                                  <img
                                    src={partnerimg}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                              </div>
                            </div>
                          )}
                          {/* {buttonVisible &&
                            !(index === 0) &&
                            !(index === bestPathinnodes?.length - 1) && (
                              <div className="">
                                <button
                                  style={{ fontSize: "14px" }}
                                  className="DeleteButtonVisible"
                                  onClick={() => handleDeleteNode(user)}
                                >
                                  <img src={Siderbardeleteicon} alt="" />
                                  Remove
                                </button>
                              </div>
                            )} */}
                        </div>
                      </Box>
                    )}
                  </>
                ))}
              </Stack>
            </Box>
            <Box
              sx={{
                pb: 10,
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                gutterBottom
                style={{ color: "#7C7C7C", marginTop: "20px" }}
              >
                Simple Path
              </Typography>

              <Stack>
                {shortPathinnodes.map((user, index) => (
                  <>
                    <Card
                      key={index}
                      variant="outlined"
                      sx={{ borderRadius: 3, boxShadow: 1, my: 0 }}
                    >
                      <CardContent
                        sx={{ display: "flex", alignItems: "center", p: 1 }}
                      >
                        {/* Avatar */}
                        <div className="rightsidebar-box-mainouter">
                          <div className="rightsidebar-box-mainouter-first">
                            <div className="rightsidebar-box-mainouter-one">
                              <Avatar sx={{ bgcolor: "primary.main", mr: 2 }}>
                                {getInitials(user.name)}
                              </Avatar>
                            </div>

                            {/* User Info */}
                            <div className="rightsidebar-box-mainouter-two">
                              <Box sx={{ flexGrow: 1 }}>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="600"
                                >
                                  {user.name}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{
                                    fontSize: 13,
                                    wordBreak: "break-word", // breaks long strings
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {user.company}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{ fontSize: 12 }}
                                  style={{
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {user?.email?.length > 18
                                    ? user?.email.slice(0, 18) + "..."
                                    : user?.email}{" "}
                                </Typography>
                                <Link
                                  href={user?.linkedin}
                                  target="_blank"
                                  // underline="hover"
                                  sx={{
                                    fontSize: 12,
                                    display: "block",
                                    color: "#0004FF",
                                  }}
                                >
                                  {user.linkedin?.split("/").pop()}
                                </Link>
                              </Box>
                            </div>
                          </div>
                          {/* Email Button */}
                          <div className="rightsidebar-box-mainouter-three">
                            <IconButton
                              component="a"
                              href={`mailto:${user?.email}`}
                              color="error"
                              className="aip-email"
                            >
                              <EmailOutlinedIcon />
                            </IconButton>
                          </div>
                        </div>
                      </CardContent>

                      {/* Bottom Score Badge */}
                    </Card>
                    {user.weight && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          my: 0,
                        }}
                      >
                        <Chip
                          label={user.weight}
                          variant="outlined"
                          sx={{
                            borderRadius: 2,
                            fontWeight: "bold",
                            margin: "10px",
                          }}
                        />
                        <span className="aip-mb-path"></span>
                        {user?.relation && (
                          <div className="aip-mb-relation">
                            <div className="siderbar-image-container-right-sidebar">
                              <div className="Siderbar-lits-images">
                                {user?.relation?.includes("Email") && (
                                  <img
                                    src={massageicon}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                                {user?.relation?.includes("LinkedIn") && (
                                  <img
                                    src={LinkedINImage}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                                {user?.relation?.includes("Organization") && (
                                  <img
                                    src={company}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                                {user?.relation?.includes("Education") && (
                                  <img
                                    src={education}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                                {user?.relation?.includes("Experience") && (
                                  <img
                                    src={experience}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                                {user?.relation?.includes("Meeting") && (
                                  <CalendarMonthIcon className="siderbar-modal-img" />
                                )}
                                {user?.relation?.includes("Partner") && (
                                  <img
                                    src={partnerimg}
                                    alt=""
                                    className="siderbar-modal-img"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </Box>
                    )}
                  </>
                ))}
              </Stack>
            </Box>
          </div>
        </Box>
      </Slide>
    </>
  );
};

export default RightSidebarMobile;
